import React, { useRef, useState } from "react";
import { message } from "antd";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText } from "@/utils/utils";
import { useWarehouseModel } from "../../warehouseModel";
import { ISCMShelfFormFields } from "../../warehouseTypes";
import { warehouseService, IWarehouseFileds, IWarehouseSearch, IWarehouseDetail, IShelfFileds, IShelfInsert, IShelfSearch, IShelfBatchInsert } from "../../warehouseService";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
//货位
export function ShelfDrawer() {

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    // const { shelfDrawer: { visible, mode }, setIShelfDrawer, selectedShelfRows, editFormVal,
    //     insertWarehouseShelf, batchInserttWarehouseShelf, updateWarehouseShelf } = useWarehouseModel();
    const { shelfDrawer: visible, editFormVal, setShelfDrawer, insertShelf, insertBatchShelf } = useWarehouseModel()
    const formRef = useRef<IYhFormRef>();
    const [isBatch, setIsBatch] = useState<boolean>(false);

    //监听批量录入字段
    const onChange = (changedValues: { [key: string]: any }) => {
        if ('isBatch' in changedValues) {
            setIsBatch(changedValues['isBatch']);
        }
    }
    const onCancel = () => {
        setShelfDrawer(false);
        setIsBatch(false);
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            formRef.current?.inst().submit();
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    const onFinish = (val: IShelfInsert | IShelfBatchInsert) => {
        // if (mode === "edit") {
        //     updateWarehouseShelf(val)
        // } else {
        // }
        isBatch ? insertBatchShelf(val) && onCancel() : insertShelf(val) && onCancel();

    }
    const isBatchItem = (bool: boolean) => {
        return bool ? [{
            type: FormItemTypeEnum.Input,
            // fieldLabel: "起始编码",
            fieldLabel: Locale["Start Code"],
            fieldName: "startCode",
            span: 24,
            // rules: [{ required: true, message: "请输入起始编码" }]
            rules: [{ required: true, message: Locale["This item is Required"] }]

        }, {
            type: FormItemTypeEnum.Input,
            // fieldLabel: "数量",
            fieldLabel: Locale["Qty"],
            fieldName: "num",
            span: 24,
            // rules: [{ required: true, message: "请输入数量" }]
            rules: [{ required: true, message: Locale["This item is Required"] }]

        }, {
            type: FormItemTypeEnum.Input,
            // fieldLabel: "前缀",
            fieldLabel: Locale["Prefix"],
            fieldName: "prefix",
            span: 24,
            // rules: [{ required: true, message: "请输入前缀" }]
            rules: [{ required: true, message: Locale["This item is Required"] }]

        }] : []
    }
    const isCode = (bool: boolean) => {
        return bool ? [] : [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "货位编码",
                fieldLabel: Locale["Shelf Code"],
                fieldName: "code",
                span: 24,
                // rules: [{ required: true, message: "请输入货位编码" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]

            }
        ]
    }
    const formConfig: IYhForm = {
        formRef,
        onFinish,
        formValues: { warehouseName: editFormVal.name },
        labelCol: { span: 6 },
        onChange,
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "所属仓库",
                fieldLabel: Locale["Warehouse"],
                fieldName: "warehouseName",
                span: 24,
                disable: true
            },
            ...isCode(isBatch),
            // {
            //     type: FormItemTypeEnum.Input,
            // fieldLabel: "货位编码",
            // fieldLabel: Locale["Founder"],
            //     fieldName: "code",
            //     span: 24,
            //     rules: [{ required: true, message: "请输入货位编码" }]
            // }
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note",
                span: 24,
            },
            ...isBatchItem(isBatch),
            {
                type: FormItemTypeEnum.Checkbox,
                // fieldLabel: "批量录入",
                fieldLabel: Locale["Batch entry"],
                fieldName: "isBatch",
                span: 24,
                // hidden: mode === "edit" ? true : false
            },
        ]
    };
    return (
        // <>货位弹框</>
        <YHDrawer
            {...{
                title: Locale["New Shelf"],
                visible,
                onCancel,
                okText: Locale["Save"],
                cancelText: Locale["Back"],
                onOk: onSubmit
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
